<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.99219 12.0001C1.99219 6.90171 6.12461 2.76929 11.223 2.76929C16.3213 2.76929 20.4537 6.90171 20.4537 12.0001C20.4537 12.5099 20.0405 12.9231 19.5306 12.9231C19.0208 12.9231 18.6076 12.5099 18.6076 12.0001C18.6076 7.92132 15.3017 4.61544 11.223 4.61544C7.14422 4.61544 3.83834 7.92132 3.83834 12.0001C3.83834 16.0779 7.14428 19.3847 11.223 19.3847C11.7328 19.3847 12.146 19.7979 12.146 20.3077C12.146 20.8176 11.7328 21.2308 11.223 21.2308C6.12455 21.2308 1.99219 17.0974 1.99219 12.0001Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5268 7.9165C12.0366 7.9165 12.4499 8.32978 12.4499 8.83958V12.6225C12.4499 12.9473 12.2791 13.2482 12.0003 13.4148L9.06972 15.1662C8.63211 15.4277 8.06535 15.285 7.80383 14.8474C7.5423 14.4097 7.68505 13.843 8.12266 13.5815L10.6037 12.0988V8.83958C10.6037 8.32978 11.017 7.9165 11.5268 7.9165Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.6441 13.7236C17.1539 13.7236 17.5672 14.1369 17.5672 14.6467V19.9887C17.5672 20.4985 17.1539 20.9118 16.6441 20.9118C16.1343 20.9118 15.7211 20.4985 15.7211 19.9887V14.6467C15.7211 14.1369 16.1343 13.7236 16.6441 13.7236Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.0493 17.3166C13.0493 16.8068 13.4626 16.3936 13.9724 16.3936H19.3145C19.8243 16.3936 20.2376 16.8068 20.2376 17.3166C20.2376 17.8264 19.8243 18.2397 19.3145 18.2397H13.9724C13.4626 18.2397 13.0493 17.8264 13.0493 17.3166Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
